export default __webpack_public_path__ + "static/media/honeymob2.032da6f5.webp";